module.exports = __webpack_public_path__ + "media/dashboard/assets/tutorials/dashboard-6bab496ff7a0ba6149ffeb49fd6871d8.gif";